'use client';

import * as React from 'react';
import { useHotelMapModal } from '@/app/components/hotel-detail/HotelMapModalProvider';
import { sendMetricIncrement } from '@/app/components/hotel-detail/metrics';
import { useInitialParams } from '@/app/components/hotel-detail/InitialParamsProvider';
import type { Brand } from '@/domainLogic/index.ts';
import BasicModalHeader from '@/app/components/search/components/Modal/LayoutElements/BasicModalHeader';
import OpenXModal from '@/app/components/search/components/Modal/OpenXModal';
import HotelMap from '@/app/components/hotel-detail/HotelMap';
import { Text } from '@lmn/design-system';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';
import { useFetchHotelStatic } from './hooks/useFetchHotelStatic';

type HotelMapModalProps = React.HTMLAttributes<HTMLElement>;

const handleMapClick = (pageType: Pages) => {
  sendMetricIncrement(`app.map.${pageType}.dynamic_map_click`);
};

export default function HotelMapModal(props: HotelMapModalProps) {
  const { isShowingMap, closeMap, showMap } = useHotelMapModal();
  const { pageType } = useInitialParams();
  const { localization } = usePageWrapperData();
  const { data: staticData } = useFetchHotelStatic();

  return (
    <OpenXModal
      isOpen={isShowingMap ?? false}
      isMobile={true}
      brand={localization.brand as Brand}
      onClose={closeMap}
      onCloseByBrowserHistory={closeMap}
      onOpenByBrowserHistory={showMap}
      fullScreen={true}
      disableAnimation={true}
      className="hotel-map-modal"
      id="hotel-map-modal"
      {...(staticData?.name ? { 'aria-label': staticData.name } : {})}
      bodyBackgroundColor="backgroundPage"
      header={{
        sticky: true,
        element: (
          <BasicModalHeader handleClose={closeMap}>
            <Text
              variant="Title4"
              css={'padding: 0 46px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;'}
            >
              {staticData?.name}
            </Text>
          </BasicModalHeader>
        ),
      }}
    >
      <HotelMap {...props} coordinates={staticData?.coordinates} onClick={() => handleMapClick(pageType)} />
    </OpenXModal>
  );
}
